import React, { useEffect, useMemo, useRef, useState } from 'react';

import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { FaCheck } from 'react-icons/fa6';
import { RiCloseCircleFill } from 'react-icons/ri';

import { useTrackingRefuel } from 'pages/TrackingRefuel/hooks/useTrackingRefuel';

import {
  BasesWrapper,
  BaseText,
  BaseIconWrapper,
  Container,
  BasesItemsContainer,
  BaseItemWrapper,
  FakeSelect,
  BaseItemText,
  BasesSelectedWrapper,
  BaseSelectedItemWrapper,
  BaseSelectedItemText,
  BaseSelectedItemIconWrapper,
  MobileTitle,
  MobileTitleWrapper,
  CloseIcon,
  FilterBasesButtonConfirm,
  FilterButtonWrapper,
} from './styles';

const FilterBases: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { installBases, handleSelectedBases } = useTrackingRefuel();
  const containerRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent): void => {
    if (
      containerRef.current &&
      !containerRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const selectedBases = useMemo(() => {
    return installBases.filter((base) => base?.isSelected);
  }, [installBases]);

  return (
    <Container ref={containerRef}>
      <BasesWrapper onClick={() => setIsOpen((prevState) => !prevState)}>
        {selectedBases.length === 0 ? (
          <BaseText>Filtre por base</BaseText>
        ) : (
          <BasesSelectedWrapper>
            {selectedBases.map((base) => (
              <BaseSelectedItemWrapper>
                <BaseSelectedItemText>{base.nickname}</BaseSelectedItemText>
                <BaseSelectedItemIconWrapper
                  onClick={() => handleSelectedBases(base)}
                >
                  <RiCloseCircleFill size={16} color="#0000003B" />
                </BaseSelectedItemIconWrapper>
              </BaseSelectedItemWrapper>
            ))}
          </BasesSelectedWrapper>
        )}
        <BaseIconWrapper>
          {isOpen ? (
            <FiChevronUp size={24} color="#3d3d3d" />
          ) : (
            <FiChevronDown size={24} color="#3d3d3d" />
          )}
        </BaseIconWrapper>
      </BasesWrapper>
      {isOpen && (
        <BasesItemsContainer>
          <MobileTitleWrapper>
            <MobileTitle>Filtre por data</MobileTitle>
            <CloseIcon onClick={() => setIsOpen(false)}>X</CloseIcon>
          </MobileTitleWrapper>
          {installBases.length > 0 &&
            installBases.map((base) => (
              <BaseItemWrapper onClick={() => handleSelectedBases(base)}>
                <FakeSelect selected={base?.isSelected}>
                  {base?.isSelected && <FaCheck size={12} color="#ffffff" />}
                </FakeSelect>
                <BaseItemText>{base.nickname}</BaseItemText>
              </BaseItemWrapper>
            ))}
          <FilterButtonWrapper>
            <FilterBasesButtonConfirm onClick={() => setIsOpen(false)}>
              Confirmar
            </FilterBasesButtonConfirm>
          </FilterButtonWrapper>
        </BasesItemsContainer>
      )}
    </Container>
  );
};

export default FilterBases;
